import React from 'react';
import './Projects.css';

const Project = ({ title, description, images }) => (
  <div className="project-block">
    <div className="project-text">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
    <div className="project-gallery">
      {images.map((img, idx) => (
        <img key={idx} src={img} alt={`${title} ${idx + 1}`} />
      ))}
    </div>
  </div>
);

const TestimonialCard = ({ text, name, video }) => (
  <div className="testimonial-card">
    <p className="testimonial-text">“{text}”</p>
    <h4 className="testimonial-name">— {name}</h4>
    {video && (
      <video className="testimonial-video" controls>
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    )}
  </div>
);

const Projects = () => {
  return (
    <div className="projects-page">
      <h1 className="projects-heading">Our Projects</h1>
      <p className="projects-intro">
        We take pride in bringing design dreams to life. Our curated projects span luxurious homes, smart spaces, and aesthetically pleasing environments — crafted with passion and precision.
      </p>

      <Project
        title="Sunset Villa Project"
        description="A premium 4BHK interior project blending modern luxury with cozy aesthetics — located in the heart of Bangalore."
        images={[
          '/images/carousel1.jpeg',
          '/images/carousel2.jpeg',
          '/images/carousel3.jpeg',
          '/images/carousel1.jpeg',
          '/images/carousel2.jpeg',
          '/images/carousel3.jpeg'
        ]}
      />

      <Project
        title="Skyline Apartment Interiors"
        description="Chic urban home design with custom modular kitchens, wardrobes, and designer lighting features for compact living."
        images={[
          '/images/p7.jpg',
          '/images/p8.jpg',
          '/images/p9.jpg',
          '/images/p10.jpg',
          '/images/p11.jpg',
          '/images/p12.jpg'
        ]}
      />

      <Project
        title="Greenfield Bungalow"
        description="Nature-inspired interiors with sustainable wood finishes, earthy tones, and seamless indoor-outdoor design integration."
        images={[
          '/images/p13.jpg',
          '/images/p14.jpg',
          '/images/p15.jpg',
          '/images/p16.jpg',
          '/images/p17.jpg',
          '/images/p18.jpg'
        ]}
      />

      <h2 className="testimonial-heading">Client Testimonials</h2>
      <div className="testimonials-section">
        <TestimonialCard
          text="Working with your team was the best decision! The designs were top-notch, and the execution was flawless."
          name="Akhil R."
          video="/videos/testimonial1.mp4"
        />
        <TestimonialCard
          text="Our home is everything we imagined — vibrant, cozy, and practical. Thank you!"
          name="Neha B."
        />
        <TestimonialCard
          text="They truly transformed our home into a masterpiece. The quality and detailing are unmatched!"
          name="Sneha D."
          video="/videos/testimonial2.mp4"
        />
        <TestimonialCard
          text="The best part was how they understood our needs and added such thoughtful touches!"
          name="Siddharth K."
        />
      </div>
    </div>
  );
};

export default Projects;
